import React from "react";
import classNames from "classnames";

export default function EditButton({
  className,
  disabled = false,
  onlyIcon = false,
  size = "small",
  label = I18n.t("papp.common.edit"),
  ...props
}) {
  return (
    <a
      className={classNames("c-LinkButton c-EditButton", {
        [className || ""]: true,
        disabled,
        "c-LinkButton-small": size === "small",
      })}
      {...props}
    >
      <i className="icon material-icons">edit</i>
      &nbsp;
      {!onlyIcon && label}
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/EditButton.jsx